'use client'
import * as React from 'react'

const PortalContainerRefContext = React.createContext<React.RefObject<HTMLElement | null> | null>(
  null,
)

export function PortalContainerProvider({
  containerRef,
  children,
}: {
  containerRef: React.RefObject<HTMLElement | null>
  children: React.ReactNode
}) {
  return <PortalContainerRefContext value={containerRef}>{children}</PortalContainerRefContext>
}

export function usePortalContainerRef() {
  return React.useContext(PortalContainerRefContext)
}
